// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_2nBHISIOTQ-nxRmSd5_oHz","checked":"nAva1mT_IQMLijgzU6xHS","disabled":"agXPx3JuBiLXGNdulhgBy"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/racing/css/singleButton.css
// module id = 670
// module chunks = 0